import { calmTokens as t } from '../../../shared/tokens';

export const inputStyle = {
  height: 34,
  padding: '0 10px',
  background: t.bg,
  border: `1px solid ${t.border}`,
  borderRadius: 9,
  color: t.text,
  fontFamily: t.fontUi,
  fontSize: 13,
  outline: 'none',
  minWidth: 0,
};

export const selectStyle = {
  ...inputStyle,
  appearance: 'auto',
  cursor: 'pointer',
};

export const monoStyle = {
  fontFamily: t.fontMono,
  fontVariantNumeric: 'tabular-nums',
};
